import { NgTraditional } from '@editor2/types/ngTraditional';
import { ElementConfigName } from '@editor2/types/pageElements';
import { BookConflictDetector } from './book/bookConflictDetector';
import { ChapterConflictDetector } from './chapter/chapterConflictDetector';
import { ChapterReorderConflictDetector } from './chapter/chapterReorderConflictDetector';
import { ElementConflictDetector } from './element/elementConflictDetector';
import { PageConflictDetector } from './page/pageConflictDetector';
import { PageGroupConflictDetector } from './pageGroup/pageGroupConflictDetector';

export const getConflictDetector = (node) => {
	const { type } = node;

	let detector;

	switch (true) {
		case type === NgTraditional.Book: {
			detector = new BookConflictDetector();
			break;
		}

		case type === NgTraditional.Chapter: {
			detector = new ChapterConflictDetector();
			break;
		}

		case type === NgTraditional.PageGroup: {
			detector = new PageGroupConflictDetector();
			break;
		}

		case type === NgTraditional.Page: {
			detector = new PageConflictDetector();
			break;
		}

		case !!ElementConfigName[type]: {
			detector = new ElementConflictDetector();
			break;
		}

		case !!node['chapters']: {
			detector = new ChapterReorderConflictDetector();
			break;
		}

		default: {
			// Some diff nodes (e.g. lecture_slide_decks reorder) have no `type` and
			// are not managed by the editor — safely skip them.
			if (type) {
				console.warn(`[conflictDetector] No conflict detector for node type: ${type}`);
			}
			break;
		}
	}

	return detector;
};
